export default __webpack_public_path__ + "f51ff7a8c62d31a2c7fb895a80b4ff8e.svg";